import React, { useEffect, useState } from 'react';
import {
  Button,
  Paper,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  InputAdornment,
  Tabs,
  Tab,
  Box,
  Chip,
  Grid,
  Card,
  CardContent,
  Divider,
  IconButton,
  Tooltip,
  CircularProgress
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import StarIcon from '@material-ui/icons/Star';
import StarHalfIcon from '@material-ui/icons/StarHalf';
import StarBorderIcon from '@material-ui/icons/StarBorder';

import { 
  currencyFormat, 
  isEven, 
  daysOfTheWeek, 
  mtcFrequencies 
} from '../../../../services/common';
import moment from 'moment';

function calculateMonthlyValue(amount, origFrequency, amountType, laborDetails) {
  console.log('calculateMonthlyValue....', amountType)
  // console.log('Amount: ', amount)
  // console.log('Frequency', origFrequency)
  // console.log('Amount TYpe', amountType)
  // Convert amount to number to ensure proper calculation
  amount = Number(amount);
  const frequency = origFrequency.toLowerCase().split(' ').join('')
  
  // console.log('Adjusted frequency', frequency)
  // const annualVisits = getNumberOfVisitsPerYear(frequency)
  // Frequency multipliers (times per year)
  const frequencyMultipliers = {
      'daily': 260,
      'fourdaysperweek': 208,
      'everyotherday(m-w-f)': 156,
      'twiceaweek': 104,
      'weekly': 52,
      'bi-weekly': 26,
      'monthly': 12,
      'quarterly': 4,
      'semi-annually': 2,
      'annually': 1,
      'ondemand': 0
  };
 
  // Validate inputs
  if (!amount || isNaN(amount)) {
      if (amount === 0) return 0
      throw new Error('Invalid amount provided');
  }
  if (!frequency || !frequencyMultipliers.hasOwnProperty(frequency.toLowerCase())) {
      throw new Error('Invalid frequency provided');
  }
  if (!['perVisit', 'perCrewPerDay', 'monthly'].includes(amountType)) {
      throw new Error('Invalid amountType. Must be either "perVisit", "monthly", or "perCrewPerDay"');
  }
  
  // Get the frequency multiplier
  const annualMultiplier = frequencyMultipliers[frequency.toLowerCase()];
  if (annualMultiplier < 1) return 0
  // Calculate monthly value based on amountType
  if (amountType === 'perVisit') {
      // For perVisit: multiply by annual frequency and divide by 12 to get monthly
      return (amount * annualMultiplier) / 12;
  } else if (amountType === 'perCrewPerDay') {
    console.log('Get our pp pc...', laborDetails)
    if (!laborDetails?.length) return 0.01
    let perVisitTotal = 0
    laborDetails.forEach((item, idx) => {
      const hours = parseFloat(item.hoursPerVisit || 0);
      const men = parseInt(item.numberOfMen || 0);
      const rate = parseFloat(item.ratePerHour || 0);
      // const laborLabel = item.laborType.charAt(0).toUpperCase() + item.laborType.slice(1);
      console.log('Hours %s  Men %s  Rate %s Label %s ', hours, men, rate)
      const tot = men * hours * rate
      // return tot
      perVisitTotal += tot
      // return (
      //   <div key={item.id || idx}>
      //     {`${hours} Hours (${men} - ${laborLabel}) @ ${currencyFormat(rate)}/hr`}
      //   </div>
      // );
    })
    console.log('perVisitTotal', perVisitTotal)
    const annualCost = perVisitTotal * annualMultiplier;
    const monthlyValue = annualCost / 12;
    console.log('Monthly Value', monthlyValue)
    return monthlyValue
  } else {
      // For monthly amounts: multiply by the number of payments per year and divide by 12
      return amount
  }
}
// Site Review Priority Algorithm
// Add this to your HMICrewAssignmentPage.js or create a separate utility file

const calculateSiteReviewPriority = (site, allSites) => {
  let score = 0;
  let factors = [];
  
  // 1. BASE SCORE: Time since last review (0-40 points)
  const monthsSinceReview = getMonthsSinceLastReview(site);
  if (monthsSinceReview === null) {
    // Never reviewed - highest time priority
    score += 40;
    factors.push(`Never reviewed (+40)`);
  } else if (monthsSinceReview >= 12) {
    score += 35;
    factors.push(`${monthsSinceReview} months overdue (+35)`);
  } else if (monthsSinceReview >= 6) {
    score += 25;
    factors.push(`${monthsSinceReview} months since review (+25)`);
  } else if (monthsSinceReview >= 3) {
    score += 10;
    factors.push(`${monthsSinceReview} months since review (+10)`);
  }
  
  // 2. CUSTOMER TYPE PRIORITY (0-25 points)
  if (site.customerType?.toLowerCase().includes('county') || 
      site.customerType?.toLowerCase().includes('government') ||
      site.customerType?.toLowerCase().includes('municipal')) {
    score += 25;
    factors.push(`County/Government (+25)`);
  } else if (site.customerType?.toLowerCase().includes('commercial')) {
    score += 10;
    factors.push(`Commercial (+10)`);
  } else if (site.customerType?.toLowerCase().includes('residential')) {
    score += 5;
    factors.push(`Residential (+5)`);
  }
  
  // 3. REVENUE IMPACT (0-20 points)
  const revenueScore = calculateRevenueScore(site, allSites);
  score += revenueScore.points;
  factors.push(revenueScore.factor);
  
  // 4. SERVICE FREQUENCY MULTIPLIER (0-15 points)
  const frequencyScore = calculateFrequencyScore(site);
  score += frequencyScore.points;
  factors.push(frequencyScore.factor);
  
  // 5. BONUS FACTORS (0-10 points each)
  
  // High-visibility sites (if you have this data)
  if (site.isHighVisibility || site.name?.toLowerCase().includes('main') || 
      site.address?.toLowerCase().includes('main')) {
    score += 10;
    factors.push(`High visibility location (+10)`);
  }
  
  // Sites with previous issues
  if (site.hasOutstandingIssues || site.lastReviewHadIssues) {
    score += 15;
    factors.push(`Previous issues noted (+15)`);
  }
  
  // Multiple locations for same client (relationship importance)
  const clientSiteCount = allSites.filter(s => s.clientName === site.clientName).length;
  if (clientSiteCount >= 5) {
    score += 8;
    factors.push(`Major client (${clientSiteCount} sites) (+8)`);
  } else if (clientSiteCount >= 3) {
    score += 5;
    factors.push(`Multiple sites client (+5)`);
  }
  
  return {
    totalScore: Math.round(score),
    factors,
    priority: getPriorityLevel(score),
    recommendedAction: getRecommendedAction(score, monthsSinceReview)
  };
};

// Helper function to get months since last review
const getMonthsSinceLastReview = (site, siteReviews = []) => {
  const siteReviewHistory = siteReviews.filter(review => 
    review.jobSite && review.jobSite._id === site._id
  ).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  
  if (siteReviewHistory.length === 0) return null; // Never reviewed
  
  const lastReviewDate = moment(siteReviewHistory[0].created_at);
  return moment().diff(lastReviewDate, 'months');
};

// Revenue scoring (0-20 points based on percentile)
const calculateRevenueScore = (site, allSites) => {
  const monthlyValues = allSites
    .map(s => s.monthlyValue || 0)
    .filter(val => val > 0)
    .sort((a, b) => b - a);
    
  if (monthlyValues.length === 0) return { points: 0, factor: 'No revenue data' };
  
  const siteValue = site.monthlyValue || 0;
  const percentile = getPercentile(siteValue, monthlyValues);
  
  if (percentile >= 90) {
    return { points: 20, factor: `Top 10% revenue (${currencyFormat(siteValue)}/mo) (+20)` };
  } else if (percentile >= 75) {
    return { points: 15, factor: `Top 25% revenue (${currencyFormat(siteValue)}/mo) (+15)` };
  } else if (percentile >= 50) {
    return { points: 10, factor: `Above median revenue (${currencyFormat(siteValue)}/mo) (+10)` };
  } else if (percentile >= 25) {
    return { points: 5, factor: `Lower revenue (${currencyFormat(siteValue)}/mo) (+5)` };
  } else {
    return { points: 0, factor: `Minimal revenue (${currencyFormat(siteValue)}/mo) (+0)` };
  }
};

// Frequency scoring (more frequent = higher priority)
const calculateFrequencyScore = (site) => {
  const frequency = site.frequency?.toLowerCase() || '';
  
  if (frequency.includes('daily')) {
    return { points: 15, factor: 'Daily service (+15)' };
  } else if (frequency.includes('every other day') || frequency.includes('twice a week')) {
    return { points: 12, factor: 'High frequency service (+12)' };
  } else if (frequency.includes('weekly')) {
    return { points: 8, factor: 'Weekly service (+8)' };
  } else if (frequency.includes('bi-weekly') || frequency.includes('biweekly')) {
    return { points: 5, factor: 'Bi-weekly service (+5)' };
  } else if (frequency.includes('monthly')) {
    return { points: 3, factor: 'Monthly service (+3)' };
  } else {
    return { points: 1, factor: 'Low frequency service (+1)' };
  }
};

// Utility function to calculate percentile
const getPercentile = (value, sortedArray) => {
  const index = sortedArray.findIndex(val => val <= value);
  if (index === -1) return 100; // Higher than all values
  return ((sortedArray.length - index) / sortedArray.length) * 100;
};

// Get priority level based on score
const getPriorityLevel = (score) => {
  if (score >= 80) return 'CRITICAL';
  if (score >= 60) return 'HIGH';
  if (score >= 40) return 'MEDIUM';
  if (score >= 20) return 'LOW';
  return 'MINIMAL';
};

// Get recommended action
const getRecommendedAction = (score, monthsSinceReview) => {
  if (score >= 80) {
    return 'Schedule review within 1 week';
  } else if (score >= 60) {
    return 'Schedule review within 2 weeks';
  } else if (score >= 40) {
    return 'Schedule review within 1 month';
  } else if (monthsSinceReview === null) {
    return 'Schedule initial review when convenient';
  } else {
    return 'Review when time permits';
  }
};

const isDueForReview = (site, siteReviews) => {
  // Find the latest review for this site
  const siteReviewHistory = siteReviews.filter(review => 
    review.jobSite && review.jobSite._id === site._id
  ).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  
  if (siteReviewHistory.length === 0) {
    // No reviews yet - consider due for review
    return true;
  }
  
  const lastReview = siteReviewHistory[0];
  const sixMonthsAgo = moment().subtract(6, 'months');
  const lastReviewDate = moment(lastReview.created_at);
  
  return lastReviewDate.isBefore(sixMonthsAgo);
};

// Main function to get prioritized review list
const getPrioritizedReviewList = (sites, siteReviews = []) => {
  return sites
    .filter(site => isDueForReview(site, siteReviews))
    .map(site => ({
      ...site,
      reviewPriority: calculateSiteReviewPriority(site, sites, siteReviews)
    }))
    .sort((a, b) => b.reviewPriority.totalScore - a.reviewPriority.totalScore);
};

const isSiteDueForReview = (site, siteReviews) => {
  // Find the latest review for this site
  const siteReviewHistory = siteReviews.filter(review => 
    review.jobSite && review.jobSite._id === site._id
  ).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  
  if (siteReviewHistory.length === 0) {
    // No reviews yet - consider due for review
    return true;
  }
  
  const lastReview = siteReviewHistory[0];
  const sixMonthsAgo = moment().subtract(6, 'months');
  const lastReviewDate = moment(lastReview.created_at);
  
  // Site is due if last review was more than 6 months ago
  return lastReviewDate.isBefore(sixMonthsAgo);
};

const isOverdue = (site) => {
  if (!site.lastServiceVisit || !site.frequency) return false;
  
  const nextExpected = calculateNextExpectedVisit(site.lastServiceVisit, site.frequency);
  if (!nextExpected) return false;
  
  return moment().isAfter(nextExpected);
};

const calculateNextExpectedVisit = (lastServiceVisit, frequency) => {
  if (!lastServiceVisit) return null;
  
  const lastVisit = moment(lastServiceVisit);
  const freq = frequency?.toLowerCase() || '';
  
  let nextVisit = moment(lastVisit);
  
  switch (freq) {
    case 'daily':
      nextVisit.add(1, 'day');
      break;
    case 'every other day (m-w-f)':
      nextVisit.add(2, 'days');
      break;
    case 'twice a week':
      nextVisit.add(3, 'days');
      break;
    case 'weekly':
      nextVisit.add(1, 'week');
      break;
    case 'bi-weekly':
    case 'biweekly':
      nextVisit.add(2, 'weeks');
      break;
    case 'monthly':
      nextVisit.add(1, 'month');
      break;
    case 'quarterly':
      nextVisit.add(3, 'months');
      break;
    case 'semi-annually':
      nextVisit.add(6, 'months');
      break;
    case 'annually':
      nextVisit.add(1, 'year');
      break;
    default:
      return null;
  }
  
  return nextVisit;
};

const getSiteReviewMetrics = (siteId, siteReviews) => {
  // console.log('Get Site Review Metrics...')
  const siteReviewHistory = siteReviews.filter(review => 
    ((review?.reviewData?.length) && review.jobSite && review.jobSite._id === siteId)
  ).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    // console.log('Site review hisor', siteReviewHistory)
  if (siteReviewHistory.length === 0) {
    return { lastReview: null, trend: 'neutral', score: null, hasIssues: false };
  }
  const lastReview = siteReviewHistory[0];
  
  // Calculate average rating (1-5 scale)
  const getReviewScore = (review) => {
    if (!review.reviewData || !Array.isArray(review.reviewData)) {
      return null;
    }

    const validRatings = review.reviewData.filter(item => item.rating > 0);
    if (validRatings.length === 0) return null;

    return validRatings.reduce((sum, item) => sum + item.rating, 0) / validRatings.length;
  };

  const lastScore = getReviewScore(lastReview);
  const hasIssues = lastReview.issues && lastReview.issues.length > 0;
  
  // Calculate trend
  let trend = 'neutral';
  if (siteReviewHistory.length > 1) {
    const previousScore = getReviewScore(siteReviewHistory[1]);
    if (lastScore !== null && previousScore !== null) {
      trend = lastScore > previousScore ? 'up' : lastScore < previousScore ? 'down' : 'neutral';
    }
  }

  return {
    lastReview,
    trend,
    score: lastScore,
    hasIssues,
    daysAgo: moment(lastReview.created_at).fromNow(),
    detailedRatings: lastReview.reviewData
      .filter(item => item.rating > 0)
      .map(item => ({
        name: item.name.charAt(0).toUpperCase() + item.name.slice(1),
        rating: item.rating,
        notes: item.notes
      }))
  };
};


const StarRating = ({ rating, small = false }) => {
  const classes = useStyles();
  const starClass = `${classes.starIcon} ${small ? classes.starIconSmall : ''}`;
  
  return (
    <Box display="flex" alignItems="center">
      {[...Array(5)].map((_, index) => {
        const value = rating - index;
        if (value >= 1) {
          return <StarIcon key={index} className={starClass} />;
        } else if (value > 0) {
          return <StarHalfIcon key={index} className={starClass} />;
        }
        return <StarBorderIcon key={index} className={starClass} />;
      })}
    </Box>
  );
};


const useStyles = makeStyles(theme => ({

  starIcon: {
    color: theme.palette.primary.main,
    fontSize: '1.2rem',
  },
  starIconSmall: {
    fontSize: '1rem',
  },
}));


export {
  calculateSiteReviewPriority,
  getPrioritizedReviewList,
  getMonthsSinceLastReview,
  calculateMonthlyValue,
  StarRating,
  isSiteDueForReview,
  isOverdue,
  calculateNextExpectedVisit,
  getSiteReviewMetrics
};

